export default __webpack_public_path__ + "static/Kids-2fe32917fa369043a812f45b684042ad.jpg";